import { useAnimations, useTexture } from '@react-three/drei';
import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';

export const Mage = () => {
  const gltf = useGLTF('/models/characters/Mage.glb');
  const { actions } = useAnimations(gltf.animations, gltf.scene);
  const texture = useTexture('/models/characters/mage_texture_alt_A.png');
  texture.flipY = false;

  useEffect(() => {
    // texture.flipY = false;
    // texture.needsUpdate = true;

    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;

        if (child.material.name === 'mage_texture') {
          child.material.map = texture;
          child.material.needsUpdate = true;
        }
      }
    });
  }, [gltf, texture]);

  useEffect(() => {
    actions['Idle']?.reset().fadeIn(0.5).play();
  }, [actions]);

  return (
    <primitive
      texture={texture}
      object={gltf.scene}
      position={[-2, 0, 0.5]}
      rotation={[0, 1.5, 0]}
      scale={[0.334, 0.334, 0.334]}
      castShadow
    />
  );
};
